import { getHttpClient } from 'src/http-client';

const apiUrl = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL as string;

export async function deleteAutomationRuleByIdService(args: {
  organizationName: string;
  projectId: string;
  automationIdList: Array<string>;
}) {
	try {
		const httpClient = getHttpClient();
		await httpClient.put(`${apiUrl}/delete-automation-rule/${args.organizationName}/${args.projectId}`,
			args.automationIdList.map((id) => ({ automationRuleId: id }))
		);
	} catch (err) {
		throw new Error('Delete automation rule by id error.');
	}
}